export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <img height="50" src='img/logo3.png' alt="logo"/>          
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
          <li>
              <a id="gruposDeTrabajos" href='#gruposDeTrabajo' className='page-scroll'>
                Diagnóstico de problemas
              </a>
            </li>
            <li>
              <a href='#sobreNosotros' className='page-scroll'>
                Sobre nosotros
              </a>
            </li>
            <li>
              <a href='#portfolio' className='page-scroll'>
                Capacitaciones
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                Contacto
              </a>
            </li>            
          </ul>
        </div>
      </div>
    </nav>
  )
}
